<template>
  <transition name="fade">
    <div class="ui-alert" v-show="value">
      <div class="content-wrapper">
        <i class="icon icon-close" @click="handleClose"></i>
        <h1 class="title" v-if="title">{{ title }}</h1>
        <div class="content" v-html="content"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "uiAlert",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClose() {
      this.$emit("input", false)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-alert {
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999999;
  .content-wrapper {
    width: 6.4rem;
    height: 8.74rem;
    position: relative;
    background: #ffffff;
    border-radius: 0.2rem;
    padding: 0.4rem 0;
    display: flex;
    flex-direction: column;
    .icon-close {
      display: inline-block;
      width: 0.6rem;
      height: 0.6rem;
      background: url("./images/icon_close.png") no-repeat center;
      background-size: 0.2rem 0.2rem;
      position: absolute;
      top: 0.1rem;
      right: 0.1rem;
    }
    .title {
      font-family: PingFangSC-Regular;
      font-size: 0.36rem;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.5rem;
    }
    .content {
      margin-top: 0.3rem;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #666666;
      overflow: auto;
      text-align: justify;
      line-height: 0.42rem;
      padding: 0 0.5rem;
    }
  }
}
.fade-enter {
  opacity: 0;
  .content-wrapper {
    transform: translate3d(0, -10%, 0);
  }
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
  .content-wrapper {
    transform: translate3d(0, 0, 0);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
  .content-wrapper {
    transition: all 0.3s;
  }
}
</style>
